import {useState,useEffect,useRef } from '../../InBuildImports';
import { TextField, Button, MenuItem } from "@mui/material";
import {roles,Properties,Endpoint,systemConfiguration,getDecryptedValueByProperty, isContainNumbers, postOperation,getHeadersforFileUpload ,handleEncode} from '../../../src/CommonImports';
import "../css/GUploadResume.css";


const GUploadResume = () => {

  const token = getDecryptedValueByProperty(Properties.SESSION_TOKEN_PROP);
  const studentId= getDecryptedValueByProperty(Properties.STUDENT_ID_PROP);

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNo: "",
    emailId: "",
    skills: "",
    totalExperience: 0,
    role: "",
    file: "",
    customRole:""
  });

  const roleList = roles.map((obj) => obj.value);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileError, setSelectedFileError] = useState(null);
  const [otherOptionError, setOtherOptionError] = useState(null);
  const [isSubmitting,setIsSubmitting]=useState(false);
  const fileInputRef = useRef(null);
  const Header_Json_Upload=getHeadersforFileUpload(token,handleEncode(studentId))
  

  const handleInputChange = (e) => {
   
    const name = e.target.name;
    const value = name === "email" ? e.target.value.trim() : e.target.value;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (value.trim() === "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (name === "fullName" && !isContainNumbers(value)) {
      setErrors((prev) => ({ ...prev, fullName: "" }));
    }
    if (name === "phoneNo" && !/[a-zA-Z]/.test(value)) {
      setErrors((prev) => ({ ...prev, phoneNo: "" }));
    }
    if (name === "totalExperience" && !/[a-zA-Z]/.test(value)) {
      setErrors((prev) => ({ ...prev, totalExperience: "" }));
    }

    if (name === "skils" && !/\d/.test(value)) {
      setErrors((prev) => ({ ...prev, skils: "" }));
    }
    if (
      name === "emailId" &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ) {
      setErrors((prev) => ({ ...prev, emailId: "" }));
    }
     if (name === "role"){
      setErrors((prev) => ({ ...prev, role: "" }));
     }

  };

  const handleOtherTextFieldChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
   
    if (name === "customRole") {
      setFormData((prev) => ({ ...prev, customRole: value })); 
      }
  }

  const validateField = (name, value) => {
    switch (name) {
      case "fullName":
        if (!value.trim()) return "Name is required field.";
        if (isContainNumbers(value)) return "Name cannot contain numbers.";
        break;
      case "phoneNo":
        if (!value.trim()) return "Phone number is required field.";
        if (!/^\d{10}$/.test(value))
          return "Please enter a valid phone number.";
        break;
      case "totalExperience":
        if (value === "" || value < 0) return "Please enter a valid experience.";
        if (!/^\d+$/.test(value)) return "Experience must be a valid number.";
        break;
      case "emailId":
        if (!value.trim()) return "Email is required field.";
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))
          return "Please enter a valid email address.";
        break;
      case "skills":
        if (!value.trim()) return "Skils is required field.";
        if (/\d/.test(value)) return "Skils cannot contain numbers.";
        break;
      case "role":
        if (!value.trim()) return "Role is required field.";
        break;
            default:
        return "";
    }
    return "";
  };

  const handleFileChange = (event) => {
    const file = (event.target.files[0]);

    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['doc', 'docx', 'pdf', 'txt', 'rtf'];

      if (allowedExtensions.includes(fileExtension)) {
        setSelectedFile(file);
        setSelectedFileError(null);
      } else {
        setSelectedFile(null);
        setSelectedFileError("Invalid file type. Please upload a DOC, DOCX, PDF, TXT or RTF file.");
      }
    }

  };


  const renderTextField = (label, name, type = "text", rows = 1) => (
    <div className="GUtext-field-div">
      <TextField
        label={label}
        name={name}
        type={type}
        value={formData[name]}
        onChange={handleInputChange}
        fullWidth
        multiline={rows > 1}
        rows={rows}
        error={!!errors[name]}
        helperText={errors[name] || ""}
      />
    </div>
  );
  const renderNumberField = (label, name, type = "number", rows = 1) => (
    <div className="GUtext-field-div">
      <TextField
        label={label}
        name={name}
        type={type}
        value={formData[name]}
        onChange={handleInputChange}
        fullWidth
        multiline={rows > 1}
        rows={rows}
        error={!!errors[name]}
        helperText={errors[name] || ""}
        id="YrsExperience"
      />
    </div>
  );

  function myFunction() {
    var modal = document.getElementById("GUmyModal");
    var span = document.getElementsByClassName("GUclose")[0];
    setFormData({
      fullName: "",
      phoneNo: "",
      emailId: "",
      skills: "",
      totalExperience: 0,
      role: "",
      file: "",
    });
    setErrors({});
    setSubmitError("");


    modal.style.display = "block";


    span.onclick = function () {
      modal.style.display = "none";
    };


    window.onclick = function (event) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    };
  }



  const renderEmailRespons = (recipientName) => {
    const htmlPart = `<!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Email</title>
      </head>
      <body>
          <p> Dear ${recipientName},<br> !!Greetings from Grastech3!!</p>
              <p>Thank you for reaching out! I appreciate the time you took to inquire with us. Our team will contact you during working days Monday to Friday between 9:30AM to 8PM IST.</p>
              <p>For immediate assistance, you can still reach out to us on +91-8452041545</p>
              <footer><p>Best,<br> Grastech3 Team</p></footer>
      </body>
      </html>`;
    return htmlPart;
  };


  const handleSubmit = async (e) => {
     e.preventDefault();
    setSubmitError("");
    const isValid = validateForm();
    const filePath = document.getElementById('browseFile').value;
    const customRoleObj = document.getElementById('customRole');

    
    console.log("customRoleObj"+customRoleObj)
    if (customRoleObj) {
      if (!customRoleObj.value) {
      setOtherOptionError('Please specify your role.');
      console.log("Please specify your role.");
      return;
      }else{
        setOtherOptionError(null);
      }
      
    }
    if (selectedFileError) {
      console.log("Invalid File Format..");
      return;
    }
    if (filePath === "") {
      setSelectedFileError("Please upload resume.");
      return;
    }
    if (isValid) {
      
      const formDataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        if ('role' === key) {
          if (formData[key]=='Other') {
            formDataToSend.append(key, formData['customRole']);
          }else{
            formDataToSend.append(key, formData[key]);
          }
        }
        else if ('file' === key) {
          formDataToSend.append(key, selectedFile);
        }
        else {
          formDataToSend.append(key, formData[key]);
        }
      });
      setIsSubmitting(true)
        const url=systemConfiguration.HOST +Endpoint.UPLOAD_RESUME
        const response = await postOperation(url,formDataToSend,
          Header_Json_Upload
        );
        myFunction();
        setFormData({
          fullName: "",
          phoneNo: "",
          emailId: "",
          skills: "",
          totalExperience: 0,
          role: "",
          customRole: "",
          file: "",
        });
       
        setSelectedFile(null);
        setSelectedFileError(null);
        setOtherOptionError(null);
        fileInputRef.current.value = "";
     
           
      
        setIsSubmitting(false)
      
    } else {
      setSubmitError("Please fill in all fields with valid information.");
    }
  };

  const validateForm = () => {
    const formErrors = {};
    let isValid = true;

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) {
        formErrors[key] = error;
        isValid = false;
      }
    });

    setErrors(formErrors);
    return isValid;
  };

  const TextFieldDropDown = (name, lable, option) => (
    <div className="GUtext-field-div">
      <TextField
        id="roleDropdown"
        select
        label={lable}
        name={name}
        defaultValue=""
        value={formData[name] || ""}
        onChange={handleInputChange}
       
        error={errors[name] ? true : false}
        helperText={errors[name] || ""}
      >
        {option.map((opt) => (
          <MenuItem key={opt} value={opt} style={{ height: "20px" }}>
            {opt}
          </MenuItem>
        ))}
      </TextField>
     
    </div>
  );

  useEffect(() => {

    var span = document.getElementsByClassName("GUclose")[0];
    var modal = document.getElementById("GUmyModal");

    span.onclick = function () {
      modal.style.display = "none";
    };


    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };

    var span2 = document.getElementsByClassName("GUclose2")[0];
    var modal2 = document.getElementById("GUmyModal2");

    window.onclick = function (event) {
      if (event.target == modal2) {
        modal2.style.display = "none";
      }
    };
  }, []);

  function openWindow() {
    window.open("https://www.grastech3solutions.com");
  }

  return (
    <div className="GU-form">
      <h2>Upload Resume</h2>
      {/* <form > */}
      <form onSubmit={handleSubmit}>
        {renderTextField("Full Name", "fullName")}
        {renderTextField("Phone Number", "phoneNo")}
        {renderTextField("Email Address", "emailId")}
        {renderTextField("Skills", "skills")}
        {renderNumberField("Total Years of experience ", "totalExperience")}
        {TextFieldDropDown("role", "Role", roleList)}

        {formData.role === "Other" && (
          <TextField
            label="Please specify your role"
            name="customRole"
            value={formData.customRole}
            fullWidth
            error={otherOptionError}
            helperText={otherOptionError || ""}
             style={{ marginBottom: 10 }}
            id="customRole"
            onChange={handleOtherTextFieldChange}
          
            
          />
        )}

        <div className="GUfile-input-container">
          <label htmlFor="file" className="Gfile-label">Browse_Resume(doc,docx,pdf,txt,rtf)</label>
          <input id="browseFile"
            ref={fileInputRef}
            type="file"
            onChange={handleFileChange}
            accept=".doc,.docx,.pdf,.txt,.rtf"
          />
          {selectedFileError && (
            <p className="GUerror">{selectedFileError}</p>
          )}
        </div>


        <div id="GUmyModal" className="GUmodal">
          <div className="GUmodal-content">
            <span className="GUclose">&times;</span>
            <b>
              <p>Thanks for submitting resume with Grastech3 IT Solutions Pvt Ltd.
              </p>
            </b>
            <p> Once your resume shortlisted our team will reach out to you.</p>
            <p>

              Please visit <a href="#" onClick={() => openWindow()} target="_blank">www.grastech3solutions.com</a> for more details.

            </p>

          </div>
        </div>

        <Button className="GUsubmit-btn" type="submit" variant="contained"   disabled={isSubmitting}>
          Submit
        </Button>

        {submitError && <p className="GUerror">{submitError}</p>}
      </form>

    </div>
  );
};

export default GUploadResume;
